// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SubsessionContextProperties = {
  subsession_id: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/subsession_context/jsonschema/2-0-0';
export const subsessionContextName = 'subsession_context';
export class SubsessionContext extends BaseTrackingContext<SubsessionContextProperties> {
  constructor(properties: SubsessionContextProperties) {
    super(subsessionContextName, schema, properties);
  }
}
